// extracted by mini-css-extract-plugin
export default {"rating":"UQ-z","numberOfStars":"VQ-z","count":"WQ-z","barGraphSpacing":"XQ-z","barGraph":"YQ-z"};